document.addEventListener("SVBApplyStylesBehavior", e => {
  switch (e.detail) {
    case "input-label":
      document.querySelectorAll("label.input-type_label").forEach(item => {
        const input = document.getElementById(item.getAttribute("for"));
        if (input) {
          const width = input.offsetWidth;
          const height = input.offsetHeight;
          const { lineHeight, paddingLeft } = window.getComputedStyle(input);
          if (input.value === "") {
            item.style.transform = `translateX(-${width - parseInt(paddingLeft)}px) translateY(${(height - parseInt(lineHeight)) / 2}px)`;
          } else {
            item.classList.add("label-filled");
            item.style.transform = `translateX(-${width - parseInt(paddingLeft) - 2}px) translateY(-${parseInt(lineHeight) / 2}px)`;
          }
          input.addEventListener("focus", _ => {
            item.classList.add("label-focused");
            item.style.transform = `translateX(-${width - parseInt(paddingLeft) - 2}px) translateY(-${parseInt(lineHeight) / 2}px)`;
          });
          input.addEventListener("blur", _ => {
            item.classList.remove("label-focused");
            if (input.value === "") {
              item.classList.remove("label-filled");
              item.style.transform = `translateX(-${width - parseInt(paddingLeft)}px) translateY(${(height - parseInt(lineHeight)) / 2}px)`;
            } else {
              item.classList.add("label-filled");
            }
          });
        }
      });

      document.querySelectorAll(".input-help-text_character-count").forEach(item => {
        let prevSibiling = item.previousElementSibling;
        while (prevSibiling && prevSibiling.tagName !== "INPUT") {
          prevSibiling = prevSibiling.previousElementSibling;
        }
        if (prevSibiling) {
          item.style.left = `${prevSibiling.getBoundingClientRect().left + prevSibiling.offsetWidth - item.offsetWidth}px`;
        }
      });

      document.querySelectorAll(".input-button-icon").forEach(input => {
        if (!input.classList.contains("svb-input-behavior-applied")) {
          const initialWidth = input.offsetWidth;
          const { paddingRight } = window.getComputedStyle(input);
          let button, icon;
          let nextSibiling = input.nextElementSibling;
          for (let i = 0; i < 4; i++) { //Possible next 5 sibilings can only be label -> p -> p -> img -> button
            // Button needs to be after icon, if exists
            if (!nextSibiling || nextSibiling.tagName === "INPUT") break;
            if (nextSibiling.classList.contains("input-inner-button")) {
              button = nextSibiling;
              break;
            }
            if (nextSibiling.classList.contains("input-inner-icon")) {
              icon = nextSibiling;
            }
            nextSibiling = nextSibiling.nextElementSibling;
          }
          if (icon || button) {
            let extraPaddingRight = 0;
            const buttonExtraPadding = 20;
            const iconWidth = 20; // offsetWidth not working in React for icon, probably due to time to load it
            if (button) {
              extraPaddingRight += button.offsetWidth + buttonExtraPadding;
              button.style.transform = `translateX(-${extraPaddingRight}px)`;
            }
            if (icon) {
              extraPaddingRight += iconWidth + (button ? 10 : 0);
              icon.style.transform = `translateX(-${extraPaddingRight + (button ? 0 : 20)}px)`;
            }
            if (icon && !button) extraPaddingRight += 20; // When icon is alone, padding is different
            input.style.paddingRight = `${extraPaddingRight + parseInt(paddingRight)}px`;
            input.style.width = `${initialWidth}px`;
          }
          input.classList.add("svb-input-behavior-applied");
        }
      });
      break;

    case "textarea":
      document.querySelectorAll("label.textarea_label").forEach(item => {
        const textarea = document.getElementById(item.getAttribute("for"));
        if (textarea) {
          const width = textarea.offsetWidth;
          const height = textarea.offsetHeight;
          const { lineHeight, paddingLeft } = window.getComputedStyle(textarea);
          if (textarea.value === "") {
            item.style.transform = `translateX(-${width - parseInt(paddingLeft)}px) translateY(12px)`;
          } else {
            item.classList.add("label-filled");
            item.style.transform = `translateX(-${width - parseInt(paddingLeft) - 2}px) translateY(-${parseInt(lineHeight) / 2}px)`;
          }
          textarea.addEventListener("focus", _ => {
            item.classList.add("label-focused");
            item.style.transform = `translateX(-${width - parseInt(paddingLeft) - 2}px) translateY(-${parseInt(lineHeight) / 2}px)`;
          });
          textarea.addEventListener("blur", _ => {
            item.classList.remove("label-focused");
            if (textarea.value === "") {
              item.classList.remove("label-filled");
              item.style.transform = `translateX(-${width - parseInt(paddingLeft)}px) translateY(12px)`;
            } else {
              item.classList.add("label-filled");
            }
          });
        }
      });

      document.querySelectorAll(".textarea-help-text_character-count").forEach(item => {
        let prevSibiling = item.previousElementSibling;
        while (prevSibiling && prevSibiling.tagName !== "TEXTAREA") {
          prevSibiling = prevSibiling.previousElementSibling;
        }
        if (prevSibiling) {
          item.style.left = `${prevSibiling.getBoundingClientRect().left + prevSibiling.offsetWidth - item.offsetWidth}px`;
        }
      });
      break;

    default:
      break;
  }
});







// OLD CODE BELOW - CHECK LATER

// document.addEventListener("DOMContentLoaded", function () {

//   /////// Prevent closing from click inside dropdown
//   document.querySelectorAll('.dropdown-menu').forEach(function (element) {
//     element.addEventListener('click', function (e) {
//       e.stopPropagation();
//     });
//   });

//   // make it as accordion for smaller screens
//   if (window.innerWidth < 992) {
//     // close all inner dropdowns when parent is closed
//     document.querySelectorAll('.navbar .dropdown').forEach(function (everydropdown) {
//       everydropdown.addEventListener('hidden.bs.dropdown', function () {
//         // after dropdown is hidden, then find all submenus
//         this.querySelectorAll('.megasubmenu').forEach(function (everysubmenu) {
//           // hide every submenu as well
//           everysubmenu.style.display = 'none';
//         });
//       })
//     });

//     document.querySelectorAll('.has-submenu a').forEach(function (element) {
//       element.addEventListener('click', function (e) {
//         let nextEl = this.nextElementSibling;
//         if (nextEl && nextEl.classList.contains('megasubmenu')) {
//           // prevent opening link if link needs to open dropdown
//           e.preventDefault();
//           if (nextEl.style.display == 'block') {
//             nextEl.style.display = 'none';
//           } else {
//             nextEl.style.display = 'block';
//           }
//         }
//       });
//     }) // end foreach
//   }
//   // end if innerWidth

// });
// // DOMContentLoaded  end

// var selector;
// window.onload = function () {

//   document.querySelectorAll("#stepper_dropdown").forEach((ele) => {
//     ele.addEventListener("click", (event) => {
//       const rowSelector = document.querySelector(`#${event.target.id}`)
//       rowSelector.style.display = "none"
//       document.getElementsByClassName(`stepper-mobile-expanded-container ${event.target.id}`)[0].style.display = "flex"
//       ele.nextSibling.style.display = "block"
//       ele.style.display = "none"
//     })
//   })

//   document.querySelectorAll("#stepper_up").forEach((eleUp) => {
//     eleUp.addEventListener("click", (event) => {
//       const rowSelector = document.querySelector(`#${event.target.id}`)
//       rowSelector.style.display = "flex"
//       document.getElementsByClassName(`stepper-mobile-expanded-container ${event.target.id}`)[0].style.display = "none"
//       eleUp.previousElementSibling.style.display = "block"
//       eleUp.style.display = "none"
//     })
//   })

//   const downloadPopupCheckbox = document.getElementById("download-popup-checkbox")
//   downloadPopupCheckbox?.addEventListener("change", (event) => {
//     if (event.currentTarget.checked) {
//       document.querySelector(".download-popup-chevron-down").style.display = "none"
//       document.querySelector(".download-popup-chevron-up").style.display = "block"
//       document.querySelector(".download-popup-bottom-container").style.cssText = `
//       transform: scaleY(1);
//       -webkit-transform: scaleY(1);
//       `
//     } else {
//       document.querySelector(".download-popup-bottom-container").style.cssText = `
//       transform: scaleY(0);
//       -webkit-transform: scaleY(0);
//       `
//       document.querySelector(".download-popup-chevron-down").style.display = "block"
//       document.querySelector(".download-popup-chevron-up").style.display = "none"
//     }
//   })

//   const main2Container = document.querySelector(".download-popup-container")
//   main2Container?.addEventListener("focusout", (event) => {
//     event.preventDefault()
//     if (!event.currentTarget.contains(event.relatedTarget)) {
//       downloadPopupCheckbox.checked = false
//       document.querySelector(".download-popup-chevron-down").style.display = "block"
//       document.querySelector(".download-popup-chevron-up").style.display = "none"
//       document.querySelector(".download-popup-bottom-container").style.cssText = `
//         transform: scaleY(0);
//         -webkit-transform: scaleY(0);
//         `
//     }
//   })

//   // For SVB TextArea
//   // const isError = document.querySelector("#svbTextArea")?.getAttribute("data-error")
//   // const svbTextHandler = document.querySelectorAll(".svb-text-area-control")
//   // if (isError === "true") {
//   //   const svbTextArea = document.querySelector("#svbTextArea")
//   //   svbTextArea.style.border = "1px solid #C4313A"
//   //   svbTextHandler.forEach((ele) => {
//   //     ele.style.color = "#C4313A"
//   //   })
//   // }

//   // document.querySelector("#svbTextArea").addEventListener("focusin", function () {
//   //   if (isError === "true") {
//   //     this.style.border = "1px solid #C4313A"
//   //     this.nextElementSibling.style = "color: #C4313A"

//   //   } else {
//   //     this.style.border = "1px solid #2D8AD2"
//   //     this.nextElementSibling.style = "color: #2D8AD2"
//   //   }

//   // })
//   // document.querySelector("#svbTextArea").addEventListener("blur", function () {
//   //   if (this.value !== '' && !this.classList.contains('not-empty')) {
//   //     this.classList.add('not-empty');
//   //   } else if (this.value === '') {
//   //     this.classList.remove('not-empty');
//   //   }
//   //   if (isError === "true") {
//   //     this.style.border = "1px solid #C4313A"
//   //     this.nextElementSibling.style = "color: #7D96AA"
//   //   } else {
//   //     this.style.border = "1px solid #7D96AA"
//   //     this.nextElementSibling.style = "color:#7D96AA;"
//   //   }
//   // })

//   // const textAreaMaxValue = document.getElementById("svbTextArea").maxLength
//   // document.querySelector(".svb-textarea-character-max-length").textContent = textAreaMaxValue

//   // document.getElementById('svbTextArea').addEventListener("keyup", function () {
//   //   document.querySelector(".svb-text-area-current-characters").textContent = this.value.length
//   //   if (isError === "true") {
//   //     this.style.border = "1px solid #C4313A"
//   //     this.nextElementSibling.style = "color: #C4313A"

//   //   } else {
//   //     if (this.maxLength === this.value.length) {
//   //       this.disabled
//   //       this.style.border = "1px solid #7D96AA"
//   //       this.nextElementSibling.style = "color:#7D96AA;"
//   //     } else {
//   //       this.style.border = "1px solid #2D8AD2"
//   //       this.nextElementSibling.style = "color: #2D8AD2;"
//   //     }
//   //   }
//   // })

// }